module.exports = __webpack_public_path__ + "media/images/application/template/brick-awards-b4daf871c46f647e24f7c18fb8ef91fb.svg";